import { COE, COMMERCIAL_CLASS, CONSIDER_COMPLETE, CONSIDER_INTERNAL_EXTERNAL } from './internal-filter.model';
import { SCORECARD_CLASS } from 'src/app/shared/model/internal-filter.model';
export class MatSelectModel {
  name: string;
  value: any;
}

export const InternalReportKey = {
  com: 'com',
  segmentCls: 'segmentClass',
  sup: 'sup',
  gsl: 'gsl',
  gslNumber: 'gslNumber',
  commo: 'commo',
  py: 'py',
  ytd: 'ytd',
  PDnND: 'PDnND',
  PDnM: 'PDnM',
  perfQyTQS: 'perfQyTQS',
  perfQyEDR: 'perfQyEDR',
  perfQyAPQP4Wind: 'perfQyAPQP4Wind',
  perfQyMD: 'perfQyMD',
  perfYoYCoSP: 'perfYoYCoSP',
  perfSDYTD: 'perfSDYTD',
  perfYoYCoPCO: 'perfYoYCoPCO',
  perfOTDPD: 'perfOTDPD',
  perfOTDPN: 'perfOTDPN',
  perfDyDLPD: 'perfDyDLPD',
  perfDyDLPN: 'perfDyDLPN',
  perfCnRTPD: 'perfCnRTPD',
  perfSustain: 'perfSustain',
  envW: 'envW',
  labW: 'labW',
  ethW: 'ethW',
  supW: 'supW',
  perfCnRTLT: 'perfCnRTLT',
  perfFiHeRa: 'perfFiHeRa',
  perfSW: 'perfSW',
  perfQyTQSW: 'perfQyTQSW',
  perfYoYCoPCOW: 'perfYoYCoPCOW',
  perfOTDPDW: 'perfOTDPDW',
  perfCnRTPDW: 'perfCnRTPDW',
  perfCnRTLTW: 'perfCnRTLTW',
  perfFiHeRaW: 'perfFiHeRaW',
  perfSustainW: 'perfSustainW',
  relsSW: 'relsSW',
  relsCIW: 'relsCIW',
  relsTIW: 'relsTIW',
  relsRW: 'relsRW',
  relsCFW: 'relsCFW',
  relsGFSW: 'relsGFSW',
  tsW: 'tsW',
  commerCls: 'commerCls',
  commerClsGap: 'commerClsGap'
};

export const RELATIONSHIP_KEY = {
  relsCI: 'relsCI',
  relsTI: 'relsTI',
  relsR: 'relsR',
  relsCF: 'relsCF',
  relsGFS: 'relsGFS'
};

export const RELATIONSHIP_NAME = {
  relsCI: 'Law & Regulation',
  relsTI: 'Drive Innovation',
  relsR: 'Customer Focus',
  relsCF: 'Lean Mindset',
  relsGFS: `GE's Flexibility to Switch`
};
export const RELATIONSHIP_SCORE_NAME = {
  relsCIW: 'Law & Regulation',
  relsTIW: 'Drive Innovation',
  relsRW: 'Customer Focus',
  relsCFW: 'Lean Mindset',
  relsGFSW: `GE's Flexibility to Switch`
};

export const PERFORMANCES_NAME = {
  perfQyTQSW: 'Total Quality Score',
  perfQyEDRW: 'Escaping Defects (NCR, PAC, COPQ)',
  perfYoYCoSPW: 'YoY Cost Out %',
  perfYoYCoPCOW: 'YoY Cost Out %',
  perfOTDPDW: 'OTD%',
  perfOTDPNW: 'OTD%',
  perfDyDLPDW: 'Days Late',
  perfDyDLPNW: 'Days Late',
  perfCnRTPDW: 'Payment Days vs Target',
  perfCnRTLTW: 'Lead Time vs Target',
  perfFiHeRaW: '(FHR) Financial Health Rating',
  perfSustainW: 'Sustainability'
};


export const COLOR = {
  RED: 'red',
  ORANGE: 'orange',
  GREEN: 'green',
  GREY: 'grey'
};

export class PerformanceSettings {
  name?: string;
  title: string;
  subTitle?: string;
  unit?: string;
  v?: number | string;
  trend?: any;
  n?: number;
  m?: number;
  compare?: string[];
  type?: string;
  gsl?: string;
  clr?: string; /* color */
  gaugeData?: any;

  constructor(params) {
    this.name = params.name;
    this.title = params.title;
    this.subTitle = params.subTitle;
    this.unit = params.unit;
    this.v = '';
    this.trend = { q1: {}, q2: {}, q3: {}, q4: {} };
    this.n = 0;
    this.m = 0;
    this.compare = params.compare;
    this.type = params.type;
    this.gsl = params.gsl;
    this.clr = params.clr;
  }
}

export class PerformanceScoreCard {
  totalQualityScore: PerformanceSettings;
  otdPromiseDate: PerformanceSettings;
  otdPlanNeeds: PerformanceSettings;
  escapingDefect: PerformanceSettings;
  yoyCostOutSupplierPrice: PerformanceSettings;
  yoyCostOutPCO: PerformanceSettings;
  daysLatePromisedDate: PerformanceSettings;
  daysLatePlanNeeds: PerformanceSettings;
  paymentDaysVsTarget: PerformanceSettings;
  leadTimeVsTarget: PerformanceSettings;
  perfSustain?: PerformanceSettings;
  financialHealthRating?: PerformanceSettings;
  apqp4Wind?: PerformanceSettings;
  majorDisruption?: PerformanceSettings;
  envW?: PerformanceSettings;
  labW?: PerformanceSettings;
  ethW?: PerformanceSettings;
  supW?: PerformanceSettings;

  constructor(params: any) {
    this.totalQualityScore = new PerformanceSettings(params.perfQyTQS);
    this.apqp4Wind = new PerformanceSettings(params.perfQyAPQP4Wind);
    this.majorDisruption = new PerformanceSettings(params.perfQyMD);
    this.escapingDefect = new PerformanceSettings(params.perfQyEDR);
    this.otdPromiseDate = new PerformanceSettings(params.perfOTDPD);
    this.yoyCostOutPCO = new PerformanceSettings(params.perfYoYCoPCO);
    this.yoyCostOutSupplierPrice = new PerformanceSettings(params.perfYoYCoSP);
    this.otdPlanNeeds = new PerformanceSettings(params.perfOTDPN);
    this.daysLatePromisedDate = new PerformanceSettings(params.perfDyDLPD);
    this.daysLatePlanNeeds = new PerformanceSettings(params.perfDyDLPN);
    this.paymentDaysVsTarget = new PerformanceSettings(params.perfCnRTPD);
    this.leadTimeVsTarget = new PerformanceSettings(params.perfCnRTLT);
    this.financialHealthRating = new PerformanceSettings(params.perfFiHeRa);
    this.perfSustain = new PerformanceSettings(params.perfSustain);
    this.envW = new PerformanceSettings(params.envW);
    this.labW = new PerformanceSettings(params.labW);
    this.ethW = new PerformanceSettings(params.ethW);
    this.supW = new PerformanceSettings(params.supW);
  }
}

export class RelationShipSettings {
  name: string;
  title: string;
  n: number;
  m: number;
  v: string | number;
  compare: string[];
  type: string;
  clr?: string;
  b?: string;
  e?: string;
  gaugeData?: any;

  constructor(params) {
    this.name = params.name;
    this.title = params.title;
    this.n = params.n;
    this.m = params.m;
    this.v = params.v;
    this.compare = params.compare;
    this.type = params.type;
    this.clr = params.clr;
    this.b = params.b;
    this.e = params.e;
  }
}

export class RelationShipScoreCard {
  complianceAndIntegrity: RelationShipSettings;
  technologyAndInnovation: RelationShipSettings;
  responsiveness: RelationShipSettings;
  scCompetencyAndFootprint: RelationShipSettings;
  geFlexibilityToSwitch: RelationShipSettings;

  constructor(params: any) {
    this.complianceAndIntegrity = new RelationShipSettings(params.relsCI);
    this.technologyAndInnovation = new RelationShipSettings(params.relsTI);
    this.responsiveness = new RelationShipSettings(params.relsR);
    this.scCompetencyAndFootprint = new RelationShipSettings(params.relsCF);
    this.geFlexibilityToSwitch = new RelationShipSettings(params.relsGFS);
  }
}

export class INTERNALREPORT {
  considerParentSupplier: boolean;
  considerSupplierCommodity?: boolean;
  gsl: any[];
  timeRange: string;
  poReceiptMonth: number;
  commodities: MatSelectModel[];
  locations: MatSelectModel[];
  regions: MatSelectModel[];
  parents?: MatSelectModel[];

  scorecardClass?: MatSelectModel[];
  commercialClass: MatSelectModel[];
  considerInternalExternal: MatSelectModel[];
  coe: MatSelectModel[];
  considerComplete: MatSelectModel[];
  minorComponent: MatSelectModel[];

  topTotalSpend: number;

  constructor(data, minors?) {
    this.considerParentSupplier = typeof(data.considerParentSupplier) === 'boolean' ? data.considerParentSupplier : true;
    this.considerSupplierCommodity = typeof(data.considerSupplierCommodity) === 'boolean' ? data.considerSupplierCommodity : true;
    this.gsl = data.gsl ? data.gsl : [];
    this.timeRange = data.timeRange ? data.timeRange : '4';
    this.poReceiptMonth = data.poReceiptMonth;
    this.commodities = data.commodities ? data.commodities : [];
    this.locations = data.locations ? data.locations : [];
    this.regions = data.regions ? data.regions : [];
    this.parents = data.parents ? data.parents : [];

    this.scorecardClass = data.scorecardClass ? data.scorecardClass : SCORECARD_CLASS;
    this.commercialClass = data.commercialClass ? data.commercialClass : COMMERCIAL_CLASS;
    this.considerInternalExternal = data.considerInternalExternal ? data.considerInternalExternal : [CONSIDER_INTERNAL_EXTERNAL[1]];
    this.coe = data.coe ? data.coe : COE;
    this.considerComplete = data.considerComplete ? data.considerComplete : CONSIDER_COMPLETE;
    this.minorComponent = data.minorComponent ? data.minorComponent : minors;

    this.topTotalSpend = data.topTotalSpend ? data.topTotalSpend : 0;
  }

  public convertToModel(data) {
    this.considerParentSupplier = data.considerParentSupplier;
    this.considerSupplierCommodity = data.considerSupplierCommodity;
    this.parents = data.parents.map(item => item.value);
    this.gsl = data.gsl.map((item: MatSelectModel) => item.value);
    this.timeRange = data.timeRange;
    this.poReceiptMonth = data.poReceiptMonth;
    this.commodities = data.commodities.map((item: MatSelectModel) => item.value);
    this.locations = data.locations.map((item: MatSelectModel) => item.value);
    this.regions = data.regions.map((item: MatSelectModel) => item.value);
    this.scorecardClass = data.scorecardClass.map((item: MatSelectModel) => item.value);
    this.commercialClass = data.commercialClass.map((item: MatSelectModel) => item.value);
    this.considerInternalExternal = data.considerInternalExternal.map((item: MatSelectModel) => item.value);
    this.coe = data.coe.map((item: MatSelectModel) => item.value);
    this.considerComplete = data.considerComplete.map((item: MatSelectModel) => item.value);
    this.minorComponent = data.minorComponent.map((item: MatSelectModel) => item.value);
    this.topTotalSpend = data.topTotalSpend;
  }
}


export class ExternalReport {
  considerParentSupplier: boolean;
  gsl: any[];
  timeRange: string;
  poReceiptMonth: number;
  commodities: MatSelectModel[];
  locations: MatSelectModel[];
  regions: MatSelectModel[];

  constructor(data) {
    this.considerParentSupplier = data.considerParentSupplier;
    this.gsl = data.gsl;
    this.timeRange = data.timeRange;
    this.poReceiptMonth = data.poReceiptMonth;
    this.commodities = data.commodities;
    this.locations = data.locations;
    this.regions = data.regions;
  }
}
export class KPI {
  // operator below
  belowOp?: number;
  // operator exceed
  exceedOp?: number;
  /* Min */
  mn?: number;
  /* Max*/
  mx?: number;
  /* Norm */
  nm?: number;
  /* Scoring */
  sc?: number;
  /* Strategy */
  st?: string;
  trend: any;
  /* color */
  clr?: string;

  constructor(params: KPI) {
    this.mn = params.mn;
    this.mx = params.mx;
    this.nm = params.nm;
    this.sc = params.sc;
    this.st = params.st;
    this.trend = params.trend;
    this.clr = params.clr;
    this.belowOp = params.belowOp;
    this.exceedOp = params.exceedOp;
  }
}

export class TableView {
  parentCompany: string;
  supplierName?: string;
  supplierGsl?: string;
  commodity: string;
  rowSpanParent?: number;
  rowSpanSupplier?: number;
  daysLatePlantNeeds: KPI;
  daysLatePromisedDate: KPI;
  complianceAndIntegrity: KPI;
  deliveryOTDPercentPromised: KPI;
  deliveryOtdPercentNeeds: KPI;
  escapingDefect: KPI;
  apqp4Wind: KPI;
  majorDisruption: KPI;
  geFlexibilityToSwitch: KPI;
  leadTimeVsTarget: KPI;
  missingPromisedDatePercent: KPI;
  paymentDaysVsTarget: KPI;
  performanceDeliveryOtdPercentPromised: KPI;
  performanceLeadTimeVsTarget: KPI;
  perfFiHeRa: KPI;
  performancePaymentDaysVsTarget: KPI;
  performanceFinancialHealthRating: KPI;
  performanceSustain: KPI;
  performanceQualityTotalQScore: KPI;
  performanceScore: KPI;
  performanceYTDCostOutOrCostDeflationPCO: KPI;
  promisedDateVsNeedDate: KPI;
  pyspend: KPI;
  qualityTotalQScore: KPI;
  relationshipScore: KPI;
  responsiveness: KPI;
  scCompetencyAndFootprint: KPI;
  segmentClass: string;
  technologyAndInnovation: KPI;
  ytdCostOutSupplierDeflation: KPI;
  ytdSupplierDeflation: KPI;
  ytdcostOutPCO: KPI;
  ytdspend: KPI;
  totalScore: KPI;
  isShow?: boolean;

  perfSustain: KPI;
  envW: KPI;
  labW: KPI;
  ethW: KPI;
  supW: KPI;

  commercialClass: string;
  commercialClassGap: number;

  constructor(params) {
    this.rowSpanParent = params.rowSpanParent;
    this.rowSpanSupplier = params.rowSpanSupplier;

    this.parentCompany = params.com;
    this.supplierName = params.sup;
    this.supplierGsl = params.gslNumber;
    this.commodity = params.commo;
    this.segmentClass = params.segmentCls;
    this.isShow = params.isShow;

    this.pyspend = new KPI(params[InternalReportKey.py]);
    this.ytdspend = new KPI(params[InternalReportKey.ytd]);
    this.promisedDateVsNeedDate = new KPI(params[InternalReportKey.PDnND]);
    this.missingPromisedDatePercent = new KPI(params[InternalReportKey.PDnM]);

    this.qualityTotalQScore = new KPI(params[InternalReportKey.perfQyTQS]);
    this.escapingDefect = new KPI(params[InternalReportKey.perfQyEDR]);
    this.apqp4Wind = new KPI(params[InternalReportKey.perfQyAPQP4Wind]);
    this.majorDisruption = new KPI(params[InternalReportKey.perfQyMD]);
    this.ytdCostOutSupplierDeflation = new KPI(params[InternalReportKey.perfYoYCoSP]);
    this.ytdSupplierDeflation = new KPI(params[InternalReportKey.perfSDYTD]);
    this.ytdcostOutPCO = new KPI(params[InternalReportKey.perfYoYCoPCO]);
    this.deliveryOTDPercentPromised = new KPI(params[InternalReportKey.perfOTDPD]);
    this.deliveryOtdPercentNeeds = new KPI(params[InternalReportKey.perfOTDPN]);
    this.daysLatePromisedDate = new KPI(params[InternalReportKey.perfDyDLPD]);
    this.daysLatePlantNeeds = new KPI(params[InternalReportKey.perfDyDLPN]);
    this.paymentDaysVsTarget = new KPI(params[InternalReportKey.perfCnRTPD]);
    this.leadTimeVsTarget = new KPI(params[InternalReportKey.perfCnRTLT]);
    this.perfFiHeRa = new KPI(params[InternalReportKey.perfFiHeRa]);

    this.perfSustain = new KPI(params[InternalReportKey.perfSustain]);
    this.envW = new KPI(params[InternalReportKey.envW]);
    this.labW = new KPI(params[InternalReportKey.labW]);
    this.ethW = new KPI(params[InternalReportKey.ethW]);
    this.supW = new KPI(params[InternalReportKey.supW]);

    this.performanceScore = new KPI(params[InternalReportKey.perfSW]);
    this.performanceQualityTotalQScore = new KPI(params[InternalReportKey.perfQyTQSW]);
    this.performanceYTDCostOutOrCostDeflationPCO = new KPI(params[InternalReportKey.perfYoYCoPCOW]);
    this.performanceDeliveryOtdPercentPromised = new KPI(params[InternalReportKey.perfOTDPDW]);
    this.performancePaymentDaysVsTarget = new KPI(params[InternalReportKey.perfCnRTPDW]);
    this.performanceLeadTimeVsTarget = new KPI(params[InternalReportKey.perfCnRTLTW]);
    this.performanceFinancialHealthRating = new KPI(params[InternalReportKey.perfFiHeRaW]);
    this.performanceSustain = new KPI(params[InternalReportKey.perfSustainW]);
    this.relationshipScore = new KPI(params[InternalReportKey.relsSW]);
    this.complianceAndIntegrity = new KPI(params[InternalReportKey.relsCIW]);
    this.technologyAndInnovation = new KPI(params[InternalReportKey.relsTIW]);
    this.responsiveness = new KPI(params[InternalReportKey.relsRW]);
    this.scCompetencyAndFootprint = new KPI(params[InternalReportKey.relsCFW]);
    this.geFlexibilityToSwitch = new KPI(params[InternalReportKey.relsGFSW]);
    this.totalScore = new KPI(params[InternalReportKey.tsW]);
    this.commercialClass = params.commerCls;
    this.commercialClassGap = params.commerClsGap;
  }
}

export class InternalReportModel {
  com?: string;
  gsl: InternalReportModel[];
  kpi: TableView[];
  sup?: string;
  gslNumber?: string;
  commerCls?: string;
  commerClsGap?: number;
}


export class SegmentationModel {
  gsl: string;
  parent: string;
  commodity?: string;
  periodSpend: number;
  supplierName: string;
  totalPerformanceScore: number;
  totalRelationShipScore: number;
}

